// @ts-nocheck
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Typography,
} from "@mui/material";
import ReusableParentContainer from "../../../components/Custom/ReusableParentContainer";
import {
  CustomButtonComponent,
  CustomCancelButtonComponent,
  CustomDialogComponent,
} from "../../../components/Custom/AlertDialog";
import React from "react";
import { CustomChip } from "../../../components/Custom/CustomIconButton";
import { FileUpload } from "@mui/icons-material";
import {
  getRGBAFromRGBGivenAlphaHandler,
  getCssVariableHandler,
} from "../../../utils/styles/getCssVariables";
import { alertDialogAciton } from "../../../store/actions/auth";
import { useDispatch } from "react-redux";
import { validateFileType } from "../../../utils/methods/contract/contractMethods";

const ContractorCertificatesUploadModal = ({
  contractorCertificatesFormik,
  contractorCertificatesToggledField,
  fileToDataUri,
  setContractorCertificateViewFullscreen,
  setContractorCertificateOtherInput,
  setOpenUploadCertificatesModal,
  getTotalUploadedFiles,
  setContractorCertificatesChangedField,
  setContractorCertificatesToggledField,
  contractorCertificatesSubmitLoading,
  contractorCertificateOtherInputInit,
  contractorCertificatesInitialValues,
}) => {
  const dispatch = useDispatch();

  return (
    <Modal
      open={true}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: "1000px",
        }}
      >
        <ReusableParentContainer
          style={{
            background: getCssVariableHandler({
              variableName: "--bg-theme-rgb",
            }),
            padding: "1rem 2rem",
          }}
        >
          <CustomDialogComponent
            open={true}
            onClose={(event, reason) => {
              if (reason !== "backdropClick") {
                // onClose(event, reason);
              }
            }}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>
              <Typography
                variant="h4"
                color="secondary"
                sx={
                  {
                    // textAlign: styles?.message?.textAlign || "left",
                  }
                }
              >
                {/* {title} */}
              </Typography>
            </DialogTitle>
            <DialogContent>
              {/* {getTotalUploadedFiles(contractorCertificatesToggledField) > 0  ? ( */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "0.25rem",
                }}
              >
                {undefined}
                {contractorCertificatesToggledField !== "Other"
                  ? contractorCertificatesFormik.values?.[
                      contractorCertificatesToggledField
                    ]?.files?.map((file, idx) => {
                      return (
                        <React.Fragment key={idx}>
                          {file ? (
                            <CustomChip
                              // avatar={<Avatar>{option}</Avatar>}
                              sx={{
                                height: "32px",
                                minWidth: "50px",
                                borderRadius: "28px !important",
                              }}
                              key={idx}
                              label={`${file?.name?.substring?.(0, 15)}${file?.name?.length > 15 ? "..." : ""}`}
                              onClick={() => {
                                (async () => {
                                  const fileUri = await fileToDataUri(file);
                                  setContractorCertificateViewFullscreen(
                                    (contractorCertificateViewFullscreen) => {
                                      return {
                                        ...contractorCertificateViewFullscreen,
                                        view: true,
                                        file: fileUri,
                                      };
                                    },
                                  );
                                })();
                              }}
                              onDelete={() => {
                                contractorCertificatesFormik.setValues(
                                  (values) => {
                                    return {
                                      ...values,
                                      [contractorCertificatesToggledField]: {
                                        ...values?.[
                                          contractorCertificatesToggledField
                                        ],
                                        files: values?.[
                                          contractorCertificatesToggledField
                                        ]?.files?.filter(
                                          (_, fileIdx) => fileIdx !== idx,
                                        ),
                                      },
                                    };
                                  },
                                );
                              }}
                            />
                          ) : null}
                        </React.Fragment>
                      );
                    })
                  : contractorCertificatesFormik.values?.[
                      contractorCertificatesToggledField
                    ]?.value?.[
                      contractorCertificatesFormik.values?.[
                        contractorCertificatesToggledField
                      ]?.value?.length - 1
                    ]?.files?.map((file, idx) => {
                      return (
                        <React.Fragment key={idx}>
                          {file ? (
                            <CustomChip
                              // avatar={<Avatar>{option}</Avatar>}
                              sx={{
                                height: "32px",
                                minWidth: "50px",
                                borderRadius: "28px !important",
                              }}
                              key={idx}
                              label={`${file?.name?.substring?.(0, 15)}${file?.name?.length > 15 ? "..." : ""}`}
                              onClick={() => {
                                (async () => {
                                  const fileUri = await fileToDataUri(file);
                                  setContractorCertificateViewFullscreen(
                                    (contractorCertificateViewFullscreen) => {
                                      return {
                                        ...contractorCertificateViewFullscreen,
                                        view: true,
                                        file: fileUri,
                                      };
                                    },
                                  );
                                })();
                              }}
                              onDelete={() => {
                                contractorCertificatesFormik?.setValues(
                                  (values) => {
                                    return {
                                      ...values,
                                      [contractorCertificatesToggledField]: {
                                        ...values?.[
                                          contractorCertificatesToggledField
                                        ],
                                        value: values?.[
                                          contractorCertificatesToggledField
                                        ]?.value?.map((oth) => {
                                          if (
                                            oth?.otherCertificateName ==
                                            contractorCertificatesFormik
                                              .values?.[
                                              contractorCertificatesToggledField
                                            ]?.value?.[
                                              contractorCertificatesFormik
                                                .values?.[
                                                contractorCertificatesToggledField
                                              ]?.value?.length - 1
                                            ]?.otherCertificateName
                                          ) {
                                            return {
                                              ...oth,
                                              // Filter OUT the file at index idx
                                              files: oth?.files?.filter(
                                                (_, fileIdx) => fileIdx !== idx,
                                              ),
                                            };
                                          } else {
                                            return oth;
                                          }
                                        }),
                                      },
                                    };
                                  },
                                );
                              }}
                            />
                          ) : null}
                        </React.Fragment>
                      );
                    })}
              </Box>
              {/* ) : (
                null
              )} */}

              {getTotalUploadedFiles(contractorCertificatesToggledField) < 3 ? (
                <Button
                  sx={{
                    marginTop: "0.5rem",
                    borderRadius: "4px",
                    // border: "1px solid #FFF",
                    background: "transparent !important",
                    border: `1px solid ${getCssVariableHandler({
                      variableName: "--primary-pink-rgb",
                    })}`,
                    boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                    minWidth: "auto",
                    padding: "5px 3px !important",
                    width: "100%",
                  }}
                  onClick={() => {
                    document.getElementById("certificate-files-input").click();
                    // csvInputRef.current.click();
                  }}
                >
                  {
                    <>
                      <FileUpload />
                      <span>
                        Upload files (Select up to 3 files in pdf/jpeg format)
                      </span>
                    </>
                  }
                  <input
                    type="file"
                    name="file"
                    accept=".pdf,.jpeg,.jpg"
                    multiple={true}
                    id={"certificate-files-input"}
                    onChange={(e) => {
                      if (
                        e.target.files.length +
                          getTotalUploadedFiles(
                            contractorCertificatesToggledField,
                          ) >
                        3
                      ) {
                        dispatch(
                          alertDialogAciton({
                            open: true,
                            title: "Error",
                            message: "Please select at most 3 files",
                          }),
                        );
                        return;
                      }
                      if (
                        !validateFileType({
                          file: e?.target?.files,
                          allowedTypes: [
                            "application/pdf",
                            "image/jpeg",
                          ],
                          dispatch,
                        })
                      ) {
                        return;
                      }

                      const field = contractorCertificatesToggledField;
                      contractorCertificatesFormik.setValues((values) => {
                        return {
                          ...values,
                          [field]: {
                            ...values[field],
                            [field !== "Other" ? "files" : "value"]:
                              field !== "Other"
                                ? [
                                    ...(values?.[field]?.files || []),
                                    ...Array.from(e.target.files || []),
                                  ]
                                : // [...values?.[field]?.value, {
                                  //   checked: true,
                                  //   name: contractorCertificateOtherInput?.value,
                                  //   files: [...(values?.[field]?.value[values?.[field]?.value?.length - 1]?.files || []), ...(e.target.files || [])]
                                  // }]
                                  values?.[field]?.value?.map(
                                    (otherCert, otherCertIdx) => {
                                      if (
                                        otherCertIdx ===
                                        values?.[field]?.value?.length - 1
                                      ) {
                                        return {
                                          ...otherCert,
                                          files: [
                                            ...(values?.[field]?.value[
                                              values?.[field]?.value?.length - 1
                                            ]?.files || []),
                                            ...(e.target.files || []),
                                          ],
                                        };
                                      } else {
                                        return otherCert;
                                      }
                                    },
                                  ),
                          },
                        };
                      });
                    }}
                    style={{
                      width: "1px",
                      visibility: "hidden",
                    }}
                    // ref={csvInputRef}
                  />
                </Button>
              ) : null}
            </DialogContent>
            <DialogActions>
              <CustomCancelButtonComponent
                onClick={() => {
                  setContractorCertificatesChangedField("");
                  setContractorCertificatesToggledField("");
                  setOpenUploadCertificatesModal(false);
                  setContractorCertificateOtherInput({
                    ...contractorCertificateOtherInputInit,
                  });
                  contractorCertificatesFormik.resetForm({
                    values: contractorCertificatesInitialValues,
                  });
                  // contractorCertificatesFormik.setValues(values => {
                  //   return {
                  //     ...values,
                  //     [contractorCertificatesToggledField]: {
                  //       ...[contractorCertificatesToggledField],
                  //       checked: false
                  //     }
                  //   }
                  // })
                }}
              >
                {"Cancel"}
              </CustomCancelButtonComponent>
              <CustomButtonComponent
                onClick={() => {
                  contractorCertificatesFormik.submitForm();
                }}
                sx={{
                  "&:disabled": {
                    color: `${getRGBAFromRGBGivenAlphaHandler({
                      rgb: `${getCssVariableHandler({
                        variableName: "--font-rgb",
                      })}`,
                      alpha: "0.65",
                    })}`,
                    background: `${getRGBAFromRGBGivenAlphaHandler({
                      rgb: `${getCssVariableHandler({
                        variableName: "--primary-pink-rgb",
                      })}`,
                      alpha: "0.65",
                    })}`,
                  },
                }}
                disabled={
                  getTotalUploadedFiles(
                    contractorCertificatesToggledField,
                    contractorCertificatesFormik.values.Other?.value?.length -
                      1,
                  ) < 1 || contractorCertificatesSubmitLoading
                }
              >
                {contractorCertificatesSubmitLoading ? (
                  <CircularProgress size={22} />
                ) : (
                  "Upload"
                )}
              </CustomButtonComponent>
            </DialogActions>
          </CustomDialogComponent>
        </ReusableParentContainer>
      </Box>
    </Modal>
  );
};

export default ContractorCertificatesUploadModal;